function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "users") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    d: "M4.05 0A2.25 2.25 0 1 1 1.8 2.25 2.25 2.25 0 0 1 4.05 0zM14.4 0a2.25 2.25 0 1 1-2.25 2.25A2.25 2.25 0 0 1 14.4 0zM0 8.4a3 3 0 0 1 3-3h1.2a3.017 3.017 0 0 1 1.254.273A3.539 3.539 0 0 0 5.4 6.3 3.6 3.6 0 0 0 6.621 9H.6a.6.6 0 0 1-.6-.6zm11.4.6h-.02a3.591 3.591 0 0 0 1.22-2.7 3.852 3.852 0 0 0-.053-.627A2.974 2.974 0 0 1 13.8 5.4H15a3 3 0 0 1 3 3 .6.6 0 0 1-.6.6zM6.3 6.3A2.7 2.7 0 1 1 9 9a2.7 2.7 0 0 1-2.7-2.7zm-2.7 7.349A3.75 3.75 0 0 1 7.349 9.9h3.3a3.75 3.75 0 0 1 3.751 3.749.751.751 0 0 1-.751.751h-9.3a.751.751 0 0 1-.749-.751z",
    transform: "translate(3 5.301)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.20cfd091dc516a3889850e244b81758b.svg";
export { ForwardRef as ReactComponent };